import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';
import Tooltip from 'components/application/Tooltip';

export default function ArchiveButton({
  disabled,
  disabledTooltip,
  isArchived,
  isCompact,
  onClick,
  onMouseEnter,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div
      className={classNames(
        'tooltip-parent',
        disabled && 'tooltip-parent--disallowed',
      )}
      onMouseEnter={onMouseEnter}
    >
      <div
        className={classNames(
          'tw-border-0 tw-border-t-1 tw-border-solid tw-border-grey-100',
          isCompact ? 'tw-h-12' : 'tw-h-14.5',
        )}
      >
        <TextButton
          color={isArchived ? 'blue' : 'red'}
          disabled={disabled}
          onClick={onClick}
          size='full'
        >
          {isArchived ? i18nTShared('unarchive') : i18nTShared('archive')}
        </TextButton>
      </div>
      {disabled && (
        <Tooltip
          className={classNames(isCompact ? 'tw-top-12' : 'tw-top-16')}
          placement='top'
          tooltip={disabledTooltip}
          trigger='hover'
        />
      )}
    </div>
  );
}

ArchiveButton.propTypes = {
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.node,
  isCompact: PropTypes.bool,
  isArchived: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
};

ArchiveButton.defaultProps = {
  disabled: false,
  disabledTooltip: null,
  isCompact: false,
  isArchived: false,
};
